const logotypesListInit = (block) => {
    const sliders = block ? [block[0].querySelector(".bn-logotypes-slider .swiper")] : Array.from(
        document.querySelectorAll(".bn-logotypes-slider .swiper")
    );

    if (sliders) {
        sliders.forEach((slider) => {
            if (slider) {
                const ballTrack = slider.parentNode.querySelector('.swiper-ball-track');
                const ball = ballTrack ? ballTrack.querySelector('.swiper-ball') : null;
                const updateBallPosition = (swiper) => {

                    if (!ball || !ballTrack) return;
                    const totalSlides = swiper.slides.length;
                    let slidesPerView = swiper.params.slidesPerView;
                    slidesPerView = Number(slidesPerView);

                    const pages = totalSlides - slidesPerView + 1;
                    let currentPage = swiper.realIndex;                    

                    let percent;
                    percent = (currentPage / (totalSlides - 1)) * 100;

                    ball.style.left = `${percent}%`;
                }                


                const sliderConfig = {
                    observer: true,
                    observeSlideChildren: true,
                    loop: true,
                    speed: 300,
                    slidesPerView: 2,
                    spaceBetween: 10,
                    autoplay: {
                        delay: 5000,
                    },
                    // pagination: {
                    //     el: '.swiper-pagination',
                    // },
                    allowTouchMove: slider.dataset.allowtouchmove === "0",
                    navigation: {
                        nextEl: slider.parentNode.querySelector(".swiper-button-next"),
                        prevEl: slider.parentNode.querySelector(".swiper-button-prev"),
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                        },
                        992: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        },
                        1200: {
                            slidesPerView: slider.dataset.maxlogotypes ? Number(slider.dataset.maxlogotypes) : 6,
                            spaceBetween: 35,
                        },
                    },
                    on: {
                        init: function (swiper) { updateBallPosition(swiper); },
                        slideChange: function (swiper) { updateBallPosition(swiper); },
                        resize: function (swiper) { updateBallPosition(swiper); }
                    }

                }

                let currentSlider = new Swiper(slider, sliderConfig);

                currentSlider.on( 'observerUpdate', () => {
                    currentSlider.destroy(currentSlider, true);
                    currentSlider = new Swiper(slider, sliderConfig);
                });
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        logotypesListInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/logotypes-slider', logotypesListInit);
});